module.exports = __webpack_public_path__ + "static/home-image-3-e3ceb399777b9a25b87f27678c5e8cde.jpg";